<template>
    <form-fieldset :error="error">
        <input
            :id="id"
            v-model="model"
            :type="type"
            :autocomplete="autocomplete"
            class="form-input"
            :class="fieldClass"
            :placeholder="placeholder"
            @focus="event => $emit('focus', event)"
            v-on="events"
        >
    </form-fieldset>
</template>
<script>
import FormFieldset from './FormFieldset';
import formField from '@/mixins/formField';

export default {
    components: {
        FormFieldset,
    },

    mixins: [
        formField,
    ],

    props: {
        id: {
            type: String,
            default: null,
        },

        type: {
            type: String,
            default: 'text',
        },

        autocomplete: {
            type: String,
            default: null,
        },

        placeholder: {
            type: String,
            default: null,
        },
    },

    computed: {
        /**
         * Generates object of dynamic events.
         *
         * @returns {object} List of dynamic events.
         */
        events() {
            if ('number' === this.type) {
                return {
                    wheel: (e) => e.target.blur(),
                };
            }

            return {};
        },
    },
};
</script>
